import { get, patch, destroy, post } from './httpClient'

export const getGiftcard = (query) => get('/order-voucher/list-gift-card', query)
export const addGiftcard = (body) => post('/order-voucher/create-gift-card', body)
export const updateGiftcard = (id, data) => patch(`/order-voucher/update-gift-card/${id}`, data)
export const deleteGiftcard = (ids) =>
  destroy('/order-voucher/delete-gift-card', { giftcard_id: ids })
